import { createContext, useContext, useState } from 'react';

import type { LoadingProviderProps } from './types';

const LoadingContext = createContext<LoadingProviderProps>({
  showLoading: false,
  setShowLoading: () => {},
});

const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider
      value={{
        showLoading: loading,
        setShowLoading: setLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

const useLoadingContext = () => {
  const loadingContext = useContext(LoadingContext);
  return loadingContext;
};

export { LoadingProvider, useLoadingContext, LoadingContext };
